import React from "react";

import { IProps } from "./types";
import StepProgressBar from 'react-step-progress';
import './index.css';

const OrderStatusBar: React.FC<IProps> = ({
  orderStatus,
}: IProps) => {
  const step = orderStatus === 'UNFULFILLED' ? 0 : 1

  return (
    <StepProgressBar
      startingStep={step}
      buttonWrapperClass={"display: none"}
      onSubmit={() => {}}
      steps={[
        {
          label: 'Payment Confirmed',
          name: 'Payment Confirmed',
          content: ''
        },
        {
          label: 'Waiting for Pickup',
          name: 'Waiting for Pickup',
          content: ''
        },
        {
          label: 'In Transit',
          name: 'In Transit',
          content: ''
        },
        {
          label: 'Delivered',
          name: 'Delivered',
          content: ''
        },
      ]}
    />
  )
};

export { OrderStatusBar }